import { createApiCall, MethodType, URI } from "../Api";
import { PostConsentStatementPayload } from "models/consentStatement/postConsentStatement";

export const getConsentStatement = () => {
  return createApiCall(
    MethodType.GET,
    URI.CONSENT_STATEMENT.GET_CONSENT_STATEMENT
  );
};

export const postConsentStatement = (payload: PostConsentStatementPayload) => {
  return createApiCall(
    MethodType.POST,
    URI.CONSENT_STATEMENT.POST_CONSENT_STATEMENT,
    payload
  );
};
